module.exports = __webpack_public_path__ + "img/bg-food-for-mood-1.4c69e58.svg";